<template>
<!--  #494FF7-->
  <el-container style="width: 100%; height: 100%; background: linear-gradient(135deg, #8268F9, #FFFFFF); overflow: auto;padding:20px; box-sizing: border-box" class="column">
    <div v-for="(content, index) in contents" :key="index">
      <div style="display: flex; flex-direction: column; padding:15px; border-radius: 15px;background-color: white; margin-top:20px; box-shadow: 0 6px 4px rgba(0, 0, 0, 0.1)">
        <span style="font-size: 24px; width:500px;">{{index}} {{content.question}}</span>
        <div v-for="(selectItem, i) in content.selectItems" :key="i" style="padding:15px 10px" @click="selectAnswer(index, i)">
          <div v-if="!selectItem.selected" class="row-start"  style="padding:10px">
          <div  style="width:30px; height:30px; border-radius: 50%; border:0px solid lightgray; background-color: #EBEAFD" class="row">{{selectItem.id}}</div>
          <div style="margin-left: 20px">{{selectItem.content}}</div>
          </div>
          <div v-else class="row-start" style="background-color: #8268F9; color:white; border-radius: 30px; padding:10px; font-size:24px">
          <div  style="width:30px; height:30px; border-radius: 50%;" class="row">{{selectItem.id}}</div>
          <div  style="margin-left:20px;">{{selectItem.content}}</div>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script setup>
import {ref} from "vue";

const contents = ref([{
  question: '问题陈述',
  selectItems:[
    {id:"A", content: "A选项内容", selected: false},
    {id:"B", content: "B选项内容", selected: false},
    {id:"C", content: "C选项内容", selected: false},
    {id:"D", content: "D选项内容", selected: false}
  ]
},
  {
    question: '问题陈述',
    selectItems:[
      {id:"A", content: "A选项内容", selected: false},
      {id:"B", content: "B选项内容", selected: false},
      {id:"C", content: "C选项内容", selected: false},
      {id:"D", content: "D选项内容", selected: false}
    ]
  },
  {
    question: '问题陈述',
    selectItems:[
      {id:"A", content: "A选项内容", selected: false},
      {id:"B", content: "B选项内容", selected: false},
      {id:"C", content: "C选项内容", selected: false},
      {id:"D", content: "D选项内容", selected: false}
    ]
  }]);

const selectAnswer = (index, i) =>{
  for(let ii = 0; ii < contents.value[index].selectItems.length; ii+=1){
    if (ii == i){
      contents.value[index].selectItems[ii].selected = !contents.value[index].selectItems[i].selected;
    }else{
      contents.value[index].selectItems[ii].selected = false;
    }

  }

}
</script>

<style scoped>

.column{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>